import { gql } from '@apollo/client';

export const GET_BOOKING = gql`
  query GetBooking($id: Int!) {
    booking(id: $id) {
      id
      status
      statutReservation
      travelerCount
      totalPrice
      contactInfo
      specialRequests
      package {
        id
        title
        commission
        formulas {
          id
          name
          priceType
          perPersonPrice
          roomPrices {
            single
            double
            triple
            quadruple
            quintuple
          }
        }
        agency {
          id
          name
          logo
        }
      }
      packageId
      formula {
        id
        name
        priceType
        perPersonPrice
        roomPrices {
          single
          double
          triple
          quadruple
          quintuple
        }
      }
      formulaId
      client {
        id
        firstName
        lastName
        email
        phone
        agencyId
        agency {
          id
          name
        }
      }
      clientId
      createdAt
      updatedAt
      nbrAdulte
      nbrEnfant
      nbrBebe
      nbrChambre
      nom
      prenom
      telephone
      mail
      typeReservation
      personnes
      bebes
      chambres
      paiement
      montantAvance
      montantPaye
      statutDisponibilite
      delaiOption
    }
  }
`;

export const GET_BOOKING_CHANGE_LOGS = gql`
  query GetBookingChangeLogs($bookingId: Int!) {
    bookingChangeLogs(bookingId: $bookingId) {
      id
      bookingId
      fieldKey
      label
      oldValue
      newValue
      createdAt
    }
  }
`;

export const GET_BOOKINGS = gql`
  query GetBookings($agencyId: Int!) {
    bookings(agencyId: $agencyId) {
      id
      status
      statutReservation
      travelerCount
      totalPrice
      contactInfo
      specialRequests
      package {
        id
        title
        commission
        agency {
          id
          name
          logo
        }
      }
      packageId
      formula {
        id
        name
      }
      formulaId
      client {
        id
        firstName
        lastName
        email
        phone
        agencyId
        agency {
          id
          name
        }
      }
      clientId
      createdAt
      updatedAt
      nbrAdulte
      nbrEnfant
      nbrBebe
      nbrChambre
      nom
      prenom
      telephone
      mail
      typeReservation
      personnes
      bebes
      chambres
      paiement
      montantAvance
      montantPaye
      statutDisponibilite
      delaiOption
      annulationPar
      annuleLe
    }
  }
`;

export const GET_RECEIVED_BOOKINGS = gql`
  query GetReceivedBookings($agencyId: Int!) {
    receivedBookings(agencyId: $agencyId) {
      id
      status
      statutReservation
      travelerCount
      totalPrice
      contactInfo
      specialRequests
      package {
        id
        title
        commission
        agency {
          id
          name
          logo
        }
      }
      packageId
      formula {
        id
        name
      }
      formulaId
      client {
        id
        firstName
        lastName
        email
        phone
        agencyId
        agency {
          id
          name
        }
      }
      clientId
      createdAt
      updatedAt
      nbrAdulte
      nbrEnfant
      nbrBebe
      nbrChambre
      nom
      prenom
      telephone
      mail
      typeReservation
      personnes
      bebes
      chambres
      paiement
      montantAvance
      montantPaye
      statutDisponibilite
      delaiOption
    }
  }
`;

export const GET_SENT_BOOKINGS = gql`
  query GetSentBookings($agencyId: Int!) {
    sentBookings(agencyId: $agencyId) {
      id
      status
      statutReservation
      travelerCount
      totalPrice
      contactInfo
      specialRequests
      package {
        id
        title
        commission
        agency {
          id
          name
          logo
        }
      }
      packageId
      formula {
        id
        name
      }
      formulaId
      client {
        id
        firstName
        lastName
        email
        phone
        agencyId
        agency {
          id
          name
        }
      }
      clientId
      createdAt
      updatedAt
      nbrAdulte
      nbrEnfant
      nbrBebe
      nbrChambre
      nom
      prenom
      telephone
      mail
      typeReservation
      personnes
      bebes
      chambres
      paiement
      montantAvance
      montantPaye
      statutDisponibilite
      delaiOption
    }
  }
`;

